var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBacIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E31937;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.5,557V324.2h93.2c17.1,0,31.4,2.5,42.8,7.6c11.4,5.1,20,12.1,25.8,21.1c5.8,9,8.6,19.3,8.6,31 c0,9.1-1.8,17.1-5.5,23.9c-3.6,6.9-8.6,12.5-14.9,16.8c-6.3,4.4-13.5,7.4-21.6,9.3v2.3c8.9,0.4,17.2,2.9,24.9,7.5 c7.8,4.6,14.1,11.1,18.9,19.4c4.8,8.3,7.3,18.2,7.3,29.6c0,12.3-3,23.4-9.1,33c-6.1,9.7-15.1,17.3-27,22.9 c-11.9,5.6-26.6,8.4-44,8.4H129.5z M178.7,421.6h36.5c6.7,0,12.7-1.2,18-3.6c5.3-2.4,9.4-5.8,12.5-10.2c3.1-4.4,4.6-9.7,4.6-15.8 c0-8.4-3-15.2-8.9-20.3c-5.9-5.2-14.4-7.7-25.3-7.7h-37.4V421.6z M178.7,516.7h40.1c13.7,0,23.7-2.6,30-7.9 c6.3-5.3,9.4-12.3,9.4-21.1c0-6.4-1.6-12.1-4.7-17c-3.1-4.9-7.5-8.8-13.2-11.6c-5.7-2.8-12.5-4.2-20.4-4.2h-41.2V516.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M369.6,557h-52.7l80.3-232.7h63.4L540.8,557h-52.7l-58.3-179.5H428L369.6,557z M366.3,465.5h124.5v38.4H366.3 V465.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M751.7,405.7h-49.8c-0.9-6.4-2.8-12.2-5.6-17.2c-2.8-5-6.4-9.3-10.8-12.9c-4.4-3.6-9.5-6.3-15.2-8.2 c-5.7-1.9-11.9-2.8-18.6-2.8c-12,0-22.5,3-31.5,8.9c-8.9,5.9-15.9,14.6-20.8,25.9c-4.9,11.3-7.4,25.1-7.4,41.2 c0,16.6,2.5,30.5,7.4,41.8c5,11.3,11.9,19.8,20.9,25.6c8.9,5.8,19.3,8.6,31,8.6c6.6,0,12.7-0.9,18.4-2.6c5.6-1.7,10.7-4.3,15.1-7.7 c4.4-3.4,8-7.5,11-12.3c2.9-4.8,4.9-10.4,6.1-16.6l49.8,0.2c-1.3,10.7-4.5,21-9.6,30.9c-5.1,9.9-12,18.7-20.6,26.5 c-8.6,7.8-18.8,13.9-30.7,18.4c-11.9,4.5-25.2,6.8-40.2,6.8c-20.8,0-39.3-4.7-55.6-14.1c-16.3-9.4-29.2-23-38.6-40.8 c-9.4-17.8-14.1-39.4-14.1-64.7c0-25.4,4.8-47,14.3-64.8c9.5-17.8,22.5-31.4,38.9-40.7c16.4-9.4,34.8-14,55.2-14 c13.5,0,26,1.9,37.6,5.7c11.6,3.8,21.8,9.3,30.7,16.5c8.9,7.2,16.2,16.1,21.9,26.5C746.5,380.3,750.1,392.2,751.7,405.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacIcon);
export default __webpack_public_path__ + "static/media/bac_icon.2b8d5eecf188bef5de82c22a361fa3c5.svg";
export { ForwardRef as ReactComponent };